import React, { Component, useMemo, useEffect } from "react";
import Switch from "@mui/material/Switch";
import { Link } from "react-router-dom";
import DataTable from "../_Components/DataTable";
import SwalMessage from "../_Components/SwalMessage";
import _ from "lodash";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import { AddEditeModal } from "./AddEditeModal";
import ApiAmusementTestimonial from "../../../core/api/api.amusementTestimonials";
import { Button } from "react-bootstrap";

function DataGrid({ data, setShowModalTestimonial, setSelectedTestimonial }) {
  let location = useLocation();
  const handleChange = (name) => (event) => {
    callApiService(name);
  };
  async function callApiService(item) {
    const can = (item.worthBuying != 0 && item.qualityServices != 0 && item.isthriller != 0 && !item.status) || item.status
    if (can) {
      const response = await ApiAmusementTestimonial.updateAmusementTestimonialStatus({
        id: item.id,
        status: !item.status,
      });
      if (response.succeeded == true) document.getElementById("submitButton").click();

      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    }
    else
      SwalMessage({ title: "در یکی از پارامتر ها امتیاز صفر است", iSsuccess: false });

  }

  const handleDelete = (item) => (event) => {
    deleteMessage(item);
  };
  async function deleteMessage(item) {
    Swal.fire({
      title: "عملیات حذف نظر",
      text: "ایا قصد حذف این نظر را دارید؟",
      icon: "question",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "بله",
      denyButtonText: "خیر",
      cancelButtonText: "انصراف",
      customClass: {
        actions: "my-actions",
        cancelButton: "order-1 right-gap btn btn-secondary",
        confirmButton: "order-2 btn btn-success px-5",
        denyButton: "order-3 btn btn-danger px-5",
      },
      focusCancel: true
    }).then((result) => {
      if (result.isConfirmed) {
        deleteApi(item);
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    });
  }
  async function deleteApi(item) {
    const response = await ApiAmusementTestimonial.deleteAmusementTestimonial({ id: item.id });
    if (response.succeeded == true) document.getElementById("submitButton").click();

    SwalMessage({ title: response.message, iSsuccess: response.succeeded });
  }

  const columns = useMemo(
    () => [
      {
        accessor: "id",
        Header: "#",
        minWidth: 50,
      },
      {
        accessor: "amusementServiceName",
        Header: " نام سرویس",
        minWidth: "100px",
      },
      // {
      //     accessor: "amusementPlaceName",
      //     Header: " نام مکان",
      //     minWidth: '100px',
      // },
      {
        accessor: "name",
        Header: " نام ",
        minWidth: "100px",
      },
      {
        accessor: "likeCount",
        Header: " لایک ",
        minWidth: "100px",
      },
      {
        accessor: "disLikeCount",
        Header: " دیس لایک ",
        minWidth: "100px",
      },
      {
        accessor: "pAmusementTestimonialId",
        Header: " شماره ایدی پدر ",
        minWidth: "100px",
      },
      {
        Header: "تاریخ ثبت",
        accessor: "createdPersianTime",
        minWidth: 90,
        maxWidth: 90,
        align: "center",
      },
      {
        Header: "فعال",
        minWidth: "100px",
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            <Switch
              checked={row.original.status ? true : false}
              value="row.original.status"
              color="primary"
              inputProps={{ "aria-label": "primary checkbox" }}
              onChange={handleChange(row.original)}
            />
          </div>
        ),
      },
      {
        Header: "عملیات",
        accessor: "",
        minWidth: 150,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {/* <button onClick={location.state.id=row.original.id}
                            className="btn btn-light-info btn-sm mr-2 btn-icon"
                        >
                            <i className='far fa-eye text-small'></i>
                        </button> */}
            {/* ویرایش */}
            {/* <Link variant="success"
                            key={row.original.id}
                            to={{
                                pathname: "/testimonials/1",
                                state: { id: row.original.id }
                            }}
                            className="btn btn-light-primary btn-sm mr-2 btn-icon"
                        >
                            <i className='far fa-edit text-small'></i>
                        </Link> */}
            {/* ویرایش */}
            <Button
              className="btn btn-light-primary btn-sm mr-2 btn-icon"
              title="ویرایش"
              onClick={() => {
                setSelectedTestimonial(row.original.id);
                setShowModalTestimonial(true);
              }}
            >
              <i className="far fa-edit text-small"></i>
            </Button>
            {/* حذف */}
            <button
              onClick={handleDelete(row.original)}
              className="btn btn-light-danger btn-sm btn-icon"
              type="button"
              title="حذف"
            >
              <i className="far fa-trash-alt text-small"></i>
            </button>
          </div>
        ),
      },
    ],
    [],
  );

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      {!_.isEmpty(location.state) && _.isNumber(location.state?.id) ? <AddEditeModal /> : <></>}

      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGrid;
